import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { googleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    // Parse from hash
    const hash = loc.hash?.startsWith("#") ? loc.hash.slice(1) : loc.hash;
    const params = new URLSearchParams(hash);
    const sid = params.get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const u = await googleSession(sid);
        nav(u.role === "vendor" ? "/vendor" : u.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      } catch {
        nav("/login?error=google");
      }
    })();
  }, [loc.hash, nav, googleSession]);

  return (
    <div className="min-h-[60vh] grid place-items-center">
      <div className="text-slate-500 text-sm animate-pulse">Signing you in with Google…</div>
    </div>
  );
}
